import { Button, InputNumber } from "@sellar-io/components";
import { useState } from "react";
import { InputLabel, InputContainer } from "@sellar-io/components";
import {
  Dialog,
  DialogNavigation,
  DialogContent,
  DialogCTA,
} from "../../modal/Dialog";
import { apiV2AssertError } from "../../../hooks/api/v2/apiV2Request";
import { Alert } from "../../alert/Alert";
import { useCollectionRemoveOrder } from "../../../hooks/api/v2/collections/useCollectionRemoveOrder";
import { useCollectionOrderData } from "../../../pages/collections/useCollectionOrderData";

export const RemoveOrderFromCollectionDialog = ({
  active,
  onDismiss,
  orderId,
  collectionId,
}: {
  active: boolean;
  onDismiss: () => void;
  orderId: number;
  collectionId: number;
}) => {
  return (
    <Dialog active={active} onDismiss={onDismiss}>
      <DialogNavigation
        leftIcon={"CHEVRON_DOWN"}
        onClickLeftIcon={onDismiss}
        title={"Remove order from collection?"}
      />
      {active ? (
        <RemoveOrderDialogContent
          onDismiss={onDismiss}
          orderId={orderId}
          collectionId={collectionId}
        />
      ) : (
        <DialogContent className="min-h-[260px]">
          <></>
        </DialogContent>
      )}
    </Dialog>
  );
};

const RemoveOrderDialogContent = ({
  onDismiss,
  orderId,
  collectionId,
}: {
  onDismiss: () => void;
  orderId: number;
  collectionId: number;
}) => {
  const removeOrderFromCollectionMutation =
    useCollectionRemoveOrder(collectionId);

  const initialData = useCollectionOrderData(orderId);

  const [error, setError] = useState<string>();

  const [totalWeight, setTotalWeight] = useState(initialData.totalWeight);
  const [numberOfPackages, setNumberOfPackages] = useState(
    initialData.numberOfPackages,
  );

  const removeFromCollection = () => {
    removeOrderFromCollectionMutation.mutate(
      {
        totalWeight,
        numberOfPackages,
        orderId,
      },
      {
        onSuccess: onDismiss,
        onError: (error) => {
          setError(
            apiV2AssertError(error)?.response?.data.message ?? "Unknown error",
          );
        },
      },
    );
  };

  if (!collectionId) return;

  return (
    <>
      <DialogContent className={"flex flex-col gap-2"}>
        {!!error && (
          <Alert
            type="error"
            title="An error occured"
            message={error}
            className="mb-4"
          />
        )}
        <div className="flex flex-col gap-1">
          <InputLabel>* Total weight of items to remove</InputLabel>
          <InputContainer>
            <InputNumber
              required={true}
              value={totalWeight}
              onChange={(e) => setTotalWeight(parseInt(e.target.value))}
            />
          </InputContainer>
        </div>

        <div className="flex flex-col gap-1">
          <InputLabel>* Number of items to remove</InputLabel>
          <InputContainer>
            <InputNumber
              required={true}
              value={numberOfPackages}
              onChange={(e) => setNumberOfPackages(parseInt(e.target.value))}
            />
          </InputContainer>
        </div>
      </DialogContent>
      <DialogCTA className={"flex flex-col gap-2 md:flex-row"}>
        <>
          <Button
            color="red"
            className={"w-full md:w-auto"}
            onClick={removeFromCollection}
            loading={removeOrderFromCollectionMutation.isPending}
            disabled={totalWeight === 0 || numberOfPackages === 0}
          >
            Remove from collection
          </Button>
        </>
      </DialogCTA>
    </>
  );
};
